export class AutocompleteSuggestion {
    public Id: string;

    public Suggestion: string;

    constructor(id: string, suggestion: string) {
        this.Id = id;
        this.Suggestion = suggestion;
    }
}

export class AutocompleteInput {
    public Id: string;

    public Input: string;

    constructor(id: string, input: string) {
        this.Id = id;
        this.Input = input;
    }
}
